import { action, flow, makeObservable, observable } from 'mobx';
import { NotificationStoreInstance } from '@common/stores';
import { IZipCode } from '@common/models';
import { ZipCodeService } from '@common/services';

export class ZipCodeStore {
  @observable zipCode?: IZipCode = undefined;
  @observable loading: boolean = false;

  constructor() {
    makeObservable(this, undefined, { autoBind: true });
  }

  fetchZipCode = flow(function* (this: ZipCodeStore, zipCode: string) {
    this.loading = true;

    this.zipCode = yield ZipCodeService.getZipCodeByZipcode(zipCode).catch(
      NotificationStoreInstance.onError('Failed to fetch zip code.', undefined),
    );

    this.loading = false;
  });

  @action.bound clearZipcode() {
    this.zipCode = undefined;
  }
}
